import React, { useState, useEffect } from 'react';
import {
  Button,
  Form,
  Modal,
  Row,
  Col,
  FormGroup,
  FormLabel,
  FormControl,
  FormSelect,
  Image,
  Alert
} from 'react-bootstrap';
import { FaUserPlus, FaUserEdit, FaCamera } from 'react-icons/fa';
import UserService from '../services/UserService';
import { toast } from 'react-toastify';
import FaylService from "../services/FaylService";

const UserAdd = ({ show, handleClose, user, onSave }) => {
  const [formData, setFormData] = useState({
    name: '',
    username: '',
    phone: '',
    email: '',
    prava_raqam: '',
    password: '',
    dob: '',
    role: '',
    avatar: null
  });
  
  const [roles, setRoles] = useState([]);
  const [preview, setPreview] = useState(null);
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    const fetchRoles = async () => {
      try {
        const response = await UserService.getUserRoles();
        setRoles(response.data);
      } catch (error) {
        console.error('Error fetching roles:', error);
      }
    };

    fetchRoles();
  }, []);

  useEffect(() => {
    if (user) {
      setFormData({
        name: user.name || '',
        username: user.username || '',
        phone: user.phone || '',
        email: user.email || '',
        prava_raqam: user.prava_raqam || '',
        password: '',
        dob: user.dob ? user.dob.split('T')[0] : '',
        role: user.roles?.[0]?.name || '',
        avatar: null
      });
      
      if (user.avatar) {
        let faylPath = FaylService.getAvatarPath(user.avatar);
        setPreview(faylPath);
      } else {
        setPreview(null);
      }
    } else {
      // Reset form for new user
      setFormData({
        name: '',
        username: '',
        phone: '',
        email: '',
        prava_raqam: '',
        password: '',
        dob: '',
        role: '',
        avatar: null
      });
      setPreview(null);
    }
    setErrors({});
  }, [user, show]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData(prev => ({
        ...prev,
        avatar: file
      }));

      // Create preview
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const validateForm = () => {
    const newErrors = {};
    
    if (!formData.name.trim()) {
      newErrors.name = 'Ism kiritilishi shart';
    }
    
    if (!formData.role) {
      newErrors.role = 'Rol tanlanishi shart';
    }
    
    // if (!user && !formData.password) {
    //   newErrors.password = 'Parol kiritilishi shart';
    // }
    
    if (formData.email && !/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = 'Noto\'g\'ri email formati';
    }
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      return;
    }
    
    setIsSubmitting(true);
    
    try {
      const formDataToSend = new FormData();
      
      // Append all fields to formData
      Object.keys(formData).forEach(key => {
        if (formData[key] !== null && formData[key] !== undefined) {
          formDataToSend.append(key, formData[key]);
        }
      });
      
      let response;
      if (user) {
        // Update existing user
        console.log('updatega keldi', formDataToSend)
        response = await UserService.updateUser(formDataToSend, user.id);
        console.log(response)
        toast.success('Foydalanuvchi muvaffaqiyatli yangilandi');
      } else {
        // Create new user
        console.log('createga keldi', formDataToSend)
        response = await UserService.createUser(formDataToSend);
        console.log(response)
        toast.success('Foydalanuvchi muvaffaqiyatli yaratildi');
      }
      
      handleClose();
      onSave(response);
    } catch (error) {
      console.error('Error saving user:', error);
      toast.error(error.message || 'Xatolik yuz berdi');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Modal show={show} onHide={handleClose} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>
          {user ? 'Foydalanuvchini tahrirlash' : 'Yangi foydalanuvchi qo\'shish'}
        </Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          <Row>
            <Col md={3} className="d-flex flex-column align-items-center">
              <div className="position-relative mb-3">
                <Image 
                  src={preview || '/default-avatar.png'} 
                  roundedCircle 
                  width={150} 
                  height={150}
                  style={{ objectFit: 'cover' }}
                  className="border"
                />
                <FormGroup className="position-absolute bottom-0 end-0">
                  <FormControl
                    type="file"
                    accept="image/*"
                    onChange={handleFileChange}
                    id="avatar-upload"
                    className="d-none"
                  />
                  <FormLabel 
                    htmlFor="avatar-upload" 
                    className="btn btn-primary btn-sm rounded-circle p-2 mb-0"
                    style={{ cursor: 'pointer' }}
                  >
                    <FaCamera size={16} />
                  </FormLabel>
                </FormGroup>
              </div>
            </Col>
            <Col md={9}>
              <Row>
                <Col md={6}>
                  <FormGroup className="mb-3">
                    <FormLabel>Ism *</FormLabel>
                    <FormControl
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleInputChange}
                      isInvalid={!!errors.name}
                      required
                    />
                    <FormControl.Feedback type="invalid">
                      {errors.name}
                    </FormControl.Feedback>
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup className="mb-3">
                    <FormLabel>Foydalanuvchi nomi</FormLabel>
                    <FormControl
                      type="text"
                      name="username"
                      value={formData.username}
                      onChange={handleInputChange}
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                  <FormGroup className="mb-3">
                    <FormLabel>Telefon</FormLabel>
                    <FormControl
                      type="text"
                      name="phone"
                      value={formData.phone}
                      onChange={handleInputChange}
                    />
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup className="mb-3">
                    <FormLabel>Email</FormLabel>
                    <FormControl
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      isInvalid={!!errors.email}
                    />
                    <FormControl.Feedback type="invalid">
                      {errors.email}
                    </FormControl.Feedback>
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                  <FormGroup className="mb-3">
                    <FormLabel>Prava raqami</FormLabel>
                    <FormControl
                      type="text"
                      name="prava_raqam"
                      value={formData.prava_raqam}
                      onChange={handleInputChange}
                    />
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup className="mb-3">
                    <FormLabel>Tug'ilgan sana</FormLabel>
                    <FormControl
                      type="date"
                      name="dob"
                      value={formData.dob}
                      onChange={handleInputChange}
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                  <FormGroup className="mb-3">
                    <FormLabel>Rol *</FormLabel>
                    <FormSelect
                      name="role"
                      value={formData.role}
                      onChange={handleInputChange}
                      isInvalid={!!errors.role}
                      required
                    >
                      <option value="">Rolni tanlang</option>
                      {roles.map((role) => (
                        <option key={role.id} value={role.name}>
                          {role.name}
                        </option>
                      ))}
                    </FormSelect>
                    <FormControl.Feedback type="invalid">
                      {errors.role}
                    </FormControl.Feedback>
                  </FormGroup>
                </Col>
                {!user && (
                  <Col md={6}>
                    <FormGroup className="mb-3">
                      <FormLabel>Parol</FormLabel>
                      <FormControl
                        type="password"
                        name="password"
                        value={formData.password}
                        onChange={handleInputChange}
                        isInvalid={!!errors.password}
                        // required={!user}
                      />
                      <FormControl.Feedback type="invalid">
                        {errors.password}
                      </FormControl.Feedback>
                    </FormGroup>
                  </Col>
                )}
              </Row>
              {user && (
                <Alert variant="info" className="mt-3">
                  <strong>Hisob ma'lumotlari:</strong> Agar parolni o'zgartirmoqchi bo'lsangiz, quyidagi maydonga yangi parolni kiriting.
                  <FormControl
                    type="password"
                    name="password"
                    value={formData.password}
                    onChange={handleInputChange}
                    placeholder="Yangi parol"
                    className="mt-2"
                  />
                </Alert>
              )}
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose} disabled={isSubmitting}>
            Bekor qilish
          </Button>
          <Button variant="primary" type="submit" disabled={isSubmitting}>
            {isSubmitting ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                Saqlanmoqda...
              </>
            ) : user ? (
              <>
                <FaUserEdit className="me-2" /> Saqlash
              </>
            ) : (
              <>
                <FaUserPlus className="me-2" /> Qo'shish
              </>
            )}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default UserAdd;
